'use client';

import Link from 'next/link';
import { ShieldAlert } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Button } from '@/src/shared/ui/button';

type Props = {
  locale: string;
};

export function InvalidResetLinkPanel({ locale }: Props) {
  const t = useTranslations('auth.resetPassword');

  return (
    <div role="alert" className="flex flex-col items-center gap-3 text-center">
      <ShieldAlert className="size-10 text-destructive" aria-hidden />
      <h2 className="text-base font-medium">{t('invalidLink.title')}</h2>
      <p className="text-sm text-muted-foreground">{t('invalidLink.body')}</p>
      <Button asChild className="mt-2 h-11 w-full rounded-lg text-[14px]">
        <Link href={`/${locale}/forgot-password`}>{t('invalidLink.requestNew')}</Link>
      </Button>
    </div>
  );
}
